import React, { useEffect, useState } from "react";
import { View, Text, StyleSheet, Platform } from "react-native";
import moment from "moment";

import AppTheme from "../AppTheme";
import fontStyles from "../../fonts";
import { padDigits } from "../../../helpers/utils";

const WAITING_INTERVAL = 60 * 60 * 24; // 24h

export default function CountDownTimer({ time, title, onDone = () => {} }) {
  const [timeLeft, setTimeLeft] = useState({});

  const timeCreated = moment(time);
  const waitingTime = timeCreated.add(24, "hours");

  const calculateTimeLeft = () => {
    const now = moment();
    let timeLeft = { hours: 0, minutes: 0, seconds: 0 };

    const difference = waitingTime.diff(now, "seconds");
    if (difference > WAITING_INTERVAL || difference < 0) return timeLeft;

    if (difference > 0) {
      timeLeft = {
        hours: Math.floor(difference / (60 * 60)),
        minutes: Math.floor((difference / 60) % 60),
        seconds: Math.floor(difference % 60),
      };
    } else {
      onDone();
    }

    return timeLeft;
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);
    return () => clearTimeout(timer);
  });

  return (
    <>
      <Text style={styles.title}>{title}</Text>

      {/* Counter */}
      {timeLeft.hours != undefined ||
      timeLeft.minutes != undefined ||
      timeLeft.seconds != undefined ? (
        <View style={styles.counterContainer}>
          <View style={styles.tile}>
            <Text style={fontStyles.h0}>{padDigits(timeLeft.hours, 2)}</Text>
            <Text style={fontStyles.h5medium}>hours</Text>
          </View>
          <View style={styles.separator} />
          <View style={styles.tile}>
            <Text style={fontStyles.h0}>{padDigits(timeLeft.minutes, 2)}</Text>
            <Text style={fontStyles.h5medium}>minutes</Text>
          </View>
          <View style={styles.separator} />
          <View style={styles.tile}>
            <Text style={fontStyles.h0}>{padDigits(timeLeft.seconds, 2)}</Text>
            <Text style={fontStyles.h5medium}>seconds</Text>
          </View>
        </View>
      ) : null}
    </>
  );
}

const styles = StyleSheet.create({
  title: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 14,
    lineHeight: 17,
    letterSpacing: 0.175,
    color: AppTheme.almostBlack,
    textAlign: "center",
    marginBottom: 8,
    maxWidth: "60%",
  },
  counterContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "row",
  },
  tile: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: 80,
    height: 65,
  },
  separator: {
    marginHorizontal: 4,
    width: 1,
    height: 63,
    borderRightWidth: 1,
    borderRightColor: AppTheme.lightGray,
  },
});
